import { Box, Button, Grid, Typography } from "@mui/material";
import { styled as styling } from "@mui/material/styles";

export const GridStyled = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  width: "100%",
  height: "100%",
  maxWidth: "1440px",
  padding: "0 100px",
  margin: "auto",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 24px",
    alignSelf: "stretch",
  },

  [props.theme.breakpoints.down("tablet")]: {
    padding: "48px 16px",
  },
}));

export const GridContainerStyled = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  justifyContent: "center",
  alignSelf: "stretch",
  flexShrink: "0",
  // padding: "0px 100px",
  margin: "auto",
  gap: "40px",
  height: "100%",
  maxHeight: "unset",
  width: "100%",
  overflow: "visible",
  backgroundColor: "#F0F1FE",
  position: "relative",

  /* Hide scrollbar for Chrome, Safari and Opera */
  "&::-webkit-scrollbar": {
    display: "none",
  },
  /* Hide scrollbar for IE, Edge and Firefox */
  "-ms-overflow-style": "none", // IE and Edge
  "scrollbar-width": "none", // Firefox

  [props.theme.breakpoints.down("lg")]: {
    flexDirection: "row",
    maxHeight: "unset",
    // padding: "48px 16px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "16px",
    // padding: "48px 16px 24px 16px",
    flexDirection: "column",
    maxHeight: "unset",
    overflow: "unset",
  },
}));

export const GridTagline = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  position: "sticky",
  top: "20px",
  height: "100%",
  zIndex: 500,
  backgroundColor: "#F0F1FE",

  padding: "80px 100px 40px 100px",
  justifyContent: "space-between",
  alignItems: "flex-end",
  alignSelf: "stretch",
  flexDirection: "row",

  [props.theme.breakpoints.down("lg")]: {
    padding: "48px 24px 24px 24px",
    maxWidth: "unset",
    top: "30px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    position: "relative",
    top: "unset",
    background: "transparent",
    padding: "56px 24px 0px 24px",
  },
}));

export const CardListContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  padding: "40px 100px 80px 100px",
  gap: "10px",
  alignItems: "center",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    gap: "10px",
    padding: "24px 24px 48px 24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    paddingTop: "0px",
    // maxHeight: "404px",
    // overflow: "scroll",
    maxHeight: "unset",
    overflow: "auto",
  },
}));

export const TaglineContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "24px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    gap: "24px",
    // maxWidth: "392px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    maxWidth: "none",
    alignItems: "center",
    width: "100%",
    textAlign: "center",
  },
}));

export const TitleAndCardContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  // top: "80px",b
  // gap: "40px",
  // paddingBottom: "130px",

  [props.theme.breakpoints.down("lg")]: {
    //
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    gap: "24px",
    paddingBottom: "0px",
    width: "100%",
  },
}));

export const TaglineSubContainer = styling(Grid)((props) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  gap: "8px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("tablet")]: {
    alignItems: "center",
  },
}));

export const TaglineOverline = styling(Typography)((props) => ({
  color: "#512ACC",
  fontFamily: "Manrope",
  fontSize: "18px",
  fontWeight: "600",
  lineHeight: "21.6px",
  letterSpacing: "0.27px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "14px",
    lineHeight: "16.8px",
    letterSpacing: "0.21px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    lineHeight: "16.8px",
    fontSize: "14px",
    letterSpacing: "0.21px",
  },
}));

export const TaglineTitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontSize: "36px",
  fontWeight: "400",
  fontStyle: "normal",
  lineHeight: "43.2px",
  fontFamily: "Georgia",

  i: {
    fontStyle: "italic",
  },

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "32px",
    lineHeight: "38.4px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "24px",
    lineHeight: "28.8px",
    textAlign: "center",
    width: "260px",
  },
}));

export const TaglineSubtitle = styling(Typography)((props) => ({
  color: "rgba(0, 0, 0, 0.87)",
  fontFamily: "Inter",
  fontSize: "18px",
  fontStyle: "normal",
  fontWeight: 500,
  lineHeight: "21.6px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "19.2px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: "16px",
    fontWeight: "400",
    lineHeight: "19.2px",
  },
}));

export const CardSection = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  flex: "1 0 0",
  gap: "24px",
  alignSelf: "stretch",
  minWidth: "600px",
  height: "100%",
  maxHeight: "688px",
  overflow: "scroll",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "688px",
    minWidth: "50%",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "unset",
    minWidth: "100%",
    minHeight: "30em",
    gap: "16px",
  },
}));

export const CardContainer = styling(Grid)((props) => ({
  display: "flex",
  height: "100%",
  minHeight: "405px",
  minWidth: "1000px",
  padding: "0px 80px",
  justifyContent: "center",
  alignItems: "center",
  gap: "60px",
  alignSelf: "stretch",
  borderRadius: "24px",
  border: "0.8px solid #D8D8D8",
  background: "#FFF",
  maxWidth: "1080px",

  [props.theme.breakpoints.down("lg")]: {
    padding: "0px 60px",
    gap: "40px",
    minHeight: "280px",
    minWidth: "unset",
  },

  [props.theme.breakpoints.down("tablet")]: {
    flexDirection: "column",
    padding: "20px 20px 48px 20px",
    minWidth: "unset",
    minHeight: "445px",
    gap: "0px",
    flex: "0 0 100%",
    maxWidth: "88vw",
  },
}));

export const CardImage = styling("img")((props) => ({
  height: "100%",
  width: "100%",
  flexShrink: "0",
  borderRadius: "8px",
  maxHeight: "475px",
  maxWidth: "475px",
  objectFit: "cover",

  [props.theme.breakpoints.down("lg")]: {
    maxHeight: "280px",
    maxWidth: "280px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    maxHeight: "250px",
    maxWidth: "250px",
  },
}));

export const CardTextContainer = styling(Grid)((props) => ({
  display: "flex",
  alignItems: "flex-start",
  flexDirection: "column",
  justifyContent: "center",
  gap: "16px",
  flex: "1 0 0",

  [props.theme.breakpoints.down("lg")]: {
    gap: "8px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    gap: "8px",
    textAlign: "center",
  },
}));

export const CardText = styling(Typography)((props) => ({
  color: props.type == "desc" ? "rgba(0, 0, 0, 0.60)" : "rgba(0, 0, 0, 0.87)",
  fontFamily: props.type == "desc" ? "Inter" : "Georgia",
  fontSize: props.type == "desc" ? "20px" : "32px",
  fontStyle: "normal",
  fontWeight: props.type == "desc" ? 400 : 400,
  lineHeight: props.type == "desc" ? "30px" : "44.8px",
  alignSelf: "stretch",

  [props.theme.breakpoints.down("lg")]: {
    fontSize: props.type == "desc" ? "16px" : "20px",
    fontWeight: props.type == "desc" ? 400 : 400,
    lineHeight: props.type == "desc" ? "24px" : "28px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    fontSize: props.type == "desc" ? "14px" : "16px",
    lineHeight: props.type == "desc" ? "21px" : "22.4px",
    textAlign: props.type == "desc" ? "center" : "center",
  },
}));

export const BoxContainer = styling(Box)({
  display: "flex",
  width: "100%",

  transition: "all 0.15s ease-in-out",
});

export const ButtonStyled = styling(Button)((props) => ({
  display: "flex",
  minWidth: "240px",
  width: "fit-content",
  padding: "12px 24px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  textTransform: "capitalize",
  border: "1px solid #F1CC44",
  background: "linear-gradient(180deg, #FFE36A 50%, #FFC400 122.92%)",
  boxShadow: "0 2px 4px 0 rgba(104, 77, 0, 0.40)",
  color: "rgba(0, 0, 0, 0.87)",
  textAlign: "center",
  borderRadius: "10px",
  height: "54px",
  fontSize: "20px",
  fontWeight: "700",
  lineHeight: "30px",
  letterSpacing: "0.1px",

  ":hover": {
    backgroundColor: "#FFDE24",
  },

  [props.theme.breakpoints.down("lg")]: {
    height: "48px",
    padding: "12px 24px",
    fontSize: "16px",
    lineHeight: "24px",
  },

  [props.theme.breakpoints.down("tablet")]: {
    width: "100%",
  },
}));

export const CarouselContainer = styling(Grid)((props) => ({
  position: "relative",
  width: "100%",
  overflow: "hidden",
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
}));

export const CardsWrapper = styling("div")((props) => ({
  display: "flex",
  transition: "transform 0.5s ease-in-out",
  gap: "8px",
  padding: "0 24px",
}));

export const NavigationButtons = styling(Grid)((props) => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  position: "absolute",
  top: "-50px",
  gap: "16px",
  width: "100%",
}));

export const StepButton = styling(Button)((props) => ({
  display: "flex",
  width: "48px",
  height: "48px",
  minWidth: "48px",
  padding: "10px",
  justifyContent: "center",
  alignItems: "center",
  gap: "10px",
  borderRadius: "24px",
  background: props?.disabled ? "#D4D0EE" : "#40249B",
  color: "#fff",
  boxShadow: "0px 1px 3px 1px rgba(0, 0, 0, 0.25)",
  cursor: props?.disabled ? "not-allowed" : "pointer",
  ":hover": {
    backgroundColor: props?.disabled ? "#D4D0EE" : "#40249B",
  },
}));
